import React from 'react'
import { Helmet } from 'react-helmet'
import Navbar8 from '../components/navbar8'
import Banner1 from '../components/banner1'
import Footer4 from '../components/footer4'
import './members.css'

const Members = () => {
  return (
    <div className="members-container">
      <Helmet>
        <title>CAIC: Members</title>
        <meta
          property="og:title"
          content="CAIC: Members"
        />
      </Helmet>
      <Navbar8

      />
      <Banner1 />
      
       
      <Footer4
        
      />
    </div>
  )
}

export default Members
